import { render, staticRenderFns } from "./DocumentosContrato.vue?vue&type=template&id=4f648761"
import script from "./DocumentosContrato.vue?vue&type=script&lang=js"
export * from "./DocumentosContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports